import axios from "axios";

export const surgeApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/surge`, withCredentials: true });

surgeApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("surge_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function surgeError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
